import { CampaignStepId } from '../types/campaign-step-interface'

export const encodeArrayQueryParam = (paramName: string, campaignStepIds: CampaignStepId[]) =>
  campaignStepIds.reduce((acc, next) => {
    const elem = `${paramName}[]=${next}`
    const prefix = acc.length > 0 ? '&' : ''
    return acc + prefix + elem
  }, '')
